<div class="modal-header d-flex justify-content-end align-items-start">
  <button type="button" class="btn-close" (click)="mode === 'due' ? skipForNow() : remindLater()" [disabled]="isLoading"></button>
</div>
<div class="modal-body" dir="rtl">
  <div class="d-flex flex-column justify-content-center align-items-center text-center px-3">

    <div class="icon-wrap mb-3">
      <i class="bi bi-arrow-repeat"></i>
    </div>

    <h4 class="title-24 bold navy-500" *ngIf="mode === 'due'">حان وقت تحديث ملفك الشخصي</h4>
    <h4 class="title-24 bold navy-500" *ngIf="mode === 'resume'">أكمل تحديث ملفك الشخصي</h4>

    <p class="title-16 text-muted mt-2" *ngIf="mode === 'due'">
      للحفاظ على دقة بياناتك أمام أصحاب العمل، يرجى مراجعة وتحديث ملفك الشخصي.
    </p>
    <p class="title-16 text-muted mt-2" *ngIf="mode === 'resume'">
      لديك تحديث قيد التقدم
      <span *ngIf="lastCompletedStep > 0"> (الخطوة {{ lastCompletedStep }} من {{ totalSteps }})</span>.
      أكمل المراجعة لتتمكن من التقديم على الفرص.
    </p>

    <div class="d-flex flex-wrap gap-2 justify-content-center mt-4 w-100">
      <button class="btn btn-primary bold px-4" (click)="updateNow()" [disabled]="isLoading">
        {{ mode === 'resume' ? 'متابعة التحديث' : 'تحديث الآن' }}
      </button>
      <button
        class="btn btn-white bold px-4"
        *ngIf="mode === 'due'"
        (click)="skipForNow()"
        [disabled]="isLoading">
        تخطي الآن
      </button>
      <button
        class="btn btn-white bold px-4"
        *ngIf="mode === 'resume'"
        (click)="remindLater()"
        [disabled]="isLoading">
        تذكيري لاحقاً
      </button>
    </div>

    <p class="title-14 text-muted mt-3" *ngIf="mode === 'due'">
      في حال التخطي، لن تتمكن من التقديم على أي فرصة حتى تكمل التحديث.
    </p>
  </div>
</div>
